// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".y9HM{display:flex;flex-direction:column;gap:16px;width:100%}.z6AK{--s:20px;height:20px;height:var(--s);width:20px;width:var(--s)}.ue2W+.ue2W{border-top:1px solid var(--grey-200)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionSidebarFooter": "y9HM",
	"actionSidebarFooterIcon": "z6AK",
	"actionSidebarItem": "ue2W"
};
module.exports = ___CSS_LOADER_EXPORT___;
